import { createBaseResponseSchema, paymentTypeSchema } from '@server/presentation/schema'
import { z } from 'zod'

export const discountApplicationTypeSchema = z.enum(['RECURRING', 'LIMITED'])

export const baseCouponSchema = z.object({
  couponId: z.string(),
  title: z.string(),
  discountType: z.enum(['FIXED', 'PERCENTAGE']),
  displayStatus: z.enum(['NORMAL', 'USED', 'EXPIRED', 'PENDING']),
  discountAmount: z.number(),
  discountAmountMax: z.number(),
  discountApplicationType: discountApplicationTypeSchema.optional(),
  discountedPaymentCount: z.number().int().positive().optional(),
  utcUseStart: z.string(),
  utcUseEnd: z.string(),
  utcCreatedAt: z.string(),
  utcDisplayUsedAt: z.string().nullable(),
  description: z.string(),
  paymentTypes: z.array(paymentTypeSchema),
  promotionCode: z.string().nullable().optional(),
})

export const rawCouponSchema = z.object({
  coupon_id: z.string(),
  template_id: z.number(),
  display_status: z.enum(['NORMAL', 'USED', 'EXPIRED', 'PENDING']),
  title: z.string(),
  discount_type: z.enum(['FIXED', 'PERCENTAGE']),
  discount_amount: z.number(),
  discount_amount_max: z.number(),
  discount_application_type: discountApplicationTypeSchema.optional().default('RECURRING'),
  discounted_payment_count: z.number().int().positive().optional().default(1),
  utc_use_start: z.string(),
  utc_use_end: z.string(),
  utc_used_at: z.string().nullable(),
  utc_display_used_at: z.string().nullable(),
  utc_created_at: z.string(),
  description: z.string(),
  payment_types: z.array(paymentTypeSchema),
  applicable: z.boolean(),
  promotion_code: z.string().nullable().optional(),
})

export const rawCouponResponseSchema = createBaseResponseSchema(z.array(rawCouponSchema))

export type BaseCoupon = z.infer<typeof baseCouponSchema>
export type RawCoupon = z.infer<typeof rawCouponSchema>
export type RawCouponResponse = z.infer<typeof rawCouponResponseSchema>
